import React from "react"

class AlertSuccess extends React.Component {
  render() {
    return (
      <div className="bg-green-100 text-green-700 text-semibold px-4 py-2 my-2 border-l-4 border-green-700 rounded">
        {this.props.children}
      </div>
    )
  }
}

export default AlertSuccess
